import React, { Component, Fragment } from 'react';
import { parseDate } from '../../../helpers/dates';
import DatePicker from './index';
import * as Styled from './styled';
import { resolve } from 'inversify-react';
import CalendarController from './index';
import type { ICalendarController } from '../../../lib/widget/calendar/calendar.interface';
import { CALENDAR_MODULE_IDS } from '../../../lib/widget/calendar/calendar.types';

class MyDatePicker extends Component<any, any> {
  @resolve(CalendarController) CalendarController;

  calendarController: ICalendarController;

  constructor(props, container) {
    super(props);

    this.calendarController = container.get(CALENDAR_MODULE_IDS.CALENDAR_CONTROLLER);

    this.onDateSelected = this.onDateSelected.bind(this);
    this.updateState = this.updateState.bind(this);

    this.state = {
      top: null,
      right: null,
    };

    this.calendarController.addListener(this.calendarController.events.UPDATE, this.updateState);
  }

  updateState({ top, right }) {
    this.setState({ top, right });
  }

  onDateSelected(selectedDate) {
    window.Widget.metaController.selectEvent(selectedDate.id);
    this.calendarController.hide();
  }

  render() {
    const { top, right } = this.state;

    if (!top && !right) return null;

    const {
      selectedDate,
      meta: { minDate, maxDate, daysTimes },
    } = window.Widget.metaController;

    return (
      <Fragment>
        <Styled.Wrapper top={top} right={right}>
          <DatePicker
            selectedDate={new Date(parseDate(selectedDate))}
            onDateSelected={this.onDateSelected}
            startDate={minDate}
            endDate={maxDate}
            daysTimes={daysTimes}
          />
        </Styled.Wrapper>
        <Styled.Overlay onClick={window.Widget.calendarController.hide} />
      </Fragment>
    );
  }
}

export default MyDatePicker;
